import React from "react";
import { useDispatch } from "react-redux";
import { storetheam } from "../../store/state/theam";
import Header from "../../components/Header";

function Theam() {
    const dispatch = useDispatch();

    // Function to change theme
    const changeTheme = (color) => {
      dispatch(storetheam({ bgColor: color, textColor: "2ECC71" })); 
    };

  return (
    <div>
      <Header />

      {/* Input fields for background-color and color */}
      <div className='marginTop' style={{marginTop : "200px"}}>
      <button onClick={() => changeTheme("FF5733")} style={{ backgroundColor: "#FF5733", color: "#fff", margin: "10px", padding: "10px" }}>
        Red Theme
      </button>

      <button onClick={() => changeTheme("3498DB")} style={{ backgroundColor: "#3498DB", color: "#fff", margin: "10px", padding: "10px" }}>
        Blue Theme
      </button>

      <button onClick={() => changeTheme("2ECC71")} style={{ backgroundColor: "#2ECC71", color: "#fff", margin: "10px", padding: "10px" }}>
        Green Theme
      </button>
s
       </div>
    
    </div>
  )
}

export default Theam
